import universal from 'react-universal-component';

export default universal(() => import('./PlayerTracking'));



// WEBPACK FOOTER //
// ./src/app/views/PlayerTracking/index.js